// Simulated API service
export const fetchProducts = async () => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 800));

  return [
    {
      id: 1,
      name: '24K Gold Plated Ring',
      price: '₹129.00',
      image: 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=400&h=400&fit=crop&crop=center',
      rating: 4.8,
      tag: 'Premium',
      category: 'gold'
    },
    {
      id: 2,
      name: 'Temple Gold Jhumka',
      price: '₹39.00',
      image: 'https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?w=400&h=400&fit=crop&crop=center',
      rating: 4.9,
      tag: 'Best Seller',
      category: 'jhumka'
    },
    {
      id: 3,
      name: 'Lakshmi Gold Necklace',
      price: '₹89.00',
      image: 'https://images.unsplash.com/photo-1617038260897-41a1f14a8ca0?w=400&h=400&fit=crop&crop=center',
      rating: 4.7,
      tag: 'New',
      category: 'necklace'
    },
    {
      id: 4,
      name: 'Royal Bridal Necklace',
      price: '₹149.00',
      image: 'https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=400&h=400&fit=crop&crop=center',
      rating: 4.9,
      tag: 'Premium',
      category: 'necklace'
    },
    {
      id: 5,
      name: 'Kundan Gold Necklace',
      price: '₹79.00',
      image: 'https://images.unsplash.com/photo-1694062045776-f48d9b6de57e?w=400&h=400&fit=crop&crop=center',
      rating: 4.6,
      tag: 'Sale',
      category: 'necklace'
    },
    {
      id: 6,
      name: 'Heritage Diamond Ring',
      price: '₹235.00',
      image: 'https://images.unsplash.com/photo-1599458349289-18f0ee82e6ed?w=400&h=400&fit=crop&crop=center',
      rating: 4.9,
      tag: 'Luxury',
      category: 'gold'
    },
    {
      id: 7,
      name: 'Silver Pearl Earrings',
      price: '₹189.00',
      image: 'https://images.unsplash.com/photo-1676496220343-1585b0cdcc3f?w=400&h=400&fit=crop&crop=center',
      rating: 4.7,
      tag: 'New',
      category: 'silver'
    },
    {
      id: 8,
      name: 'Gold Plated Jhumka Set',
      price: '₹49.00',
      image: 'https://plus.unsplash.com/premium_photo-1691030255383-ec9765ad5340?w=400&h=400&fit=crop&crop=center',
      rating: 4.5,
      tag: 'Popular',
      category: 'jhumka'
    },
    {
      id: 9,
      name: 'Silver Chain Necklace',
      price: '₹99.00',
      image: 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=400&h=400&fit=crop&crop=center',
      rating: 4.4,
      tag: 'Trending',
      category: 'silver'
    },
    {
      id: 10,
      name: 'Gold Plated Anklet',
      price: '₹59.00',
      image: 'https://plus.unsplash.com/premium_photo-1678730056371-eff9c5356a48?w=400&h=400&fit=crop&crop=center',
      rating: 4.3,
      tag: 'New',
      category: 'gold'
    },
    {
      id: 11,
      name: 'Bridal Gold Bangles',
      price: '₹299.00',
      image: 'https://images.unsplash.com/photo-1679156271456-d6068c543ee7?w=400&h=400&fit=crop&crop=center',
      rating: 4.8,
      tag: 'Bridal Special',
      category: 'gold'
    },
    {
      id: 12,
      name: 'Silver Pendant Set',
      price: '₹69.00',
      image: 'https://images.unsplash.com/photo-1728381115194-34fe8681035a?w=400&h=400&fit=crop&crop=center',
      rating: 4.5,
      tag: 'Popular',
      category: 'silver'
    }
  ];
};

export const fetchProductById = async (id) => {
  const products = await fetchProducts();
  return products.find(product => product.id === id);
};

export const fetchProductsByCategory = async (category) => {
  const products = await fetchProducts();
  if (category === 'all') return products;
  return products.filter(product => product.category === category);
};

export const fetchFeaturedProducts = async () => {
  const products = await fetchProducts();
  return products.slice(0, 6);
};

export const searchProducts = async (query) => {
  const products = await fetchProducts();
  return products.filter(product => 
    product.name.toLowerCase().includes(query.toLowerCase()) ||
    product.category.toLowerCase().includes(query.toLowerCase())
  );
};